var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", style: { minHeight: 60 + "vh" } },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(" Manually upload distribution file "),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("on-close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _vm._v(
            " " +
              _vm._s(_vm.distributor.id) +
              "- " +
              _vm._s(_vm.distributor.name) +
              " "
          ),
          _c(
            "section",
            { staticClass: "mt-2" },
            [
              _c(
                "b-field",
                [
                  _c(
                    "b-upload",
                    {
                      attrs: { "drag-drop": "" },
                      on: { input: _vm.handleFileUpload },
                      model: {
                        value: _vm.dropFiles,
                        callback: function ($$v) {
                          _vm.dropFiles = $$v
                        },
                        expression: "dropFiles",
                      },
                    },
                    [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          { staticClass: "content has-text-centered" },
                          [
                            _c(
                              "p",
                              [
                                _c("b-icon", {
                                  attrs: { icon: "upload", size: "is-large" },
                                }),
                              ],
                              1
                            ),
                            _c("p", [
                              _vm._v("Drop your file here or click to upload"),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tags" },
                _vm._l(_vm.dropFiles, function (file, index) {
                  return _c(
                    "span",
                    { key: index, staticClass: "tag is-primary" },
                    [
                      _vm._v(" " + _vm._s(file.name) + " "),
                      _c("button", {
                        staticClass: "delete is-small",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteDropFile(index)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
          _c(
            "b-field",
            { staticClass: "mt-2" },
            [
              _c(
                "b-checkbox",
                {
                  model: {
                    value: _vm.hasNothing,
                    callback: function ($$v) {
                      _vm.hasNothing = $$v
                    },
                    expression: "hasNothing",
                  },
                },
                [_vm._v(" Nothing to declare ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "b-button",
              { attrs: { type: "is-primary" }, on: { click: _vm.submit } },
              [_vm._v(" Submit ")]
            ),
            _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("on-close")
                  },
                },
              },
              [_vm._v(" Cancel ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }